/* eslint-disable no-undef */
(function () {
    'use strict';

    angular.module('thankview.video')
        .directive('overlayReply', ['$rootScope', 'ajax', '$window', '$q', '$timeout', 'recorderService', '$sce', function ($rootScope, ajax, $window, $q, $timeout, recorderService, $sce) {
            return {
                restrict: 'E',
                scope: true,
                templateUrl: '/templates/video/overlay-reply.html?v=' + config.version,
                link: function (scope) {
                    scope.$on('open-reply', function ($event, reply) {
                        console.log('should open overlay');

                        if (!config.user) {
                            scope.reply = angular.copy(reply);
                            // scope.reply.opt_in = true;
                            scope.reply.opt_in = false;
                            scope.auth = false;
                        } else {
                            scope.reply = {
                                video_id: reply.video_id,
                                name: config.user.name,
                                email: config.user.email,
                                opt_in: false,
                            };

                            scope.auth = true;
                        }

                        scope.opened = true;
                        // determine correct default reply option
                        // this is necessary if video replies are enabled, but text replies aren't
                        if (scope.textReplies) {
                            scope.replyOptionIndex = 0;
                        } else if (scope.videoReplies) {
                            scope.replyOptionIndex = 1;
                        }

                        scope.reply.message = '';

                        scope.recording = null;
                        scope.loading = false;

                        recorderService.reset();
                        scope.$broadcast('open-overlay');
                    });

                    scope.$on('close-overlay', function () {
                        recorderService.reset();
                    });

                    scope.init = function () {
                        scope.trustAsHtml = $sce.trustAsHtml;

                        if (config.params) {
                            scope.videoReplies = config.params.video_replies;
                            scope.textReplies = config.params.text_replies;

                            if (config.params.business) {
                                scope.businessName = config.params.business.full_name;
                                scope.privacyPolicy = config.params.business.privacy_policy;
                            }
                        }

                        // bind on recorder state
                        recorderService.onStateChange(scope.stateChange);

                        scope.fetchTranslations();
                    };

                    scope.fetchTranslations = function () {
                        var locale = $window.config.locale;
                        var business = config.params ? config.params.business : null;

                        var params = {
                            filename: 'overlay_reply',
                        };

                        if (business) {
                            params.replacements = {
                                businessName: business.full_name,
                                privacyPolicyUrl: business.privacy_policy,
                            };
                        }

                        ajax.post('/api/translate/' + locale, params).then(function (data) {
                            scope.trans = data.trans;
                        });
                    };

                    scope.toggleReplyOption = function (index) {
                        scope.replyOptionIndex = index;
                    };

                    scope.stateChange = function (state) {
                        scope.state = state;

                        if (scope.state === 'uploadComplete') {
                            scope.saveVideo();
                        }
                    };

                    scope.initWebcamRecorder = function () {
                        recorderService.webcam.open();
                    };

                    scope.openUploadVideo = function () {
                        recorderService.fileUploader.open();
                    };

                    scope.rerecord = function () {
                        var deferred = $q.defer();

                        deferred.promise.then(function () {
                            scope.recording = null;

                            recorderService.reset();
                        });

                        $rootScope.$broadcast('open-message-confirm', scope.trans['rerecord-warning'], deferred);
                    };

                    scope.reUpload = function () {
                        recorderService.fileUploader.reUpload();
                    };

                    scope.saveVideo = function () {
                        scope.recording = recorderService.getRecording();

                        recorderService.review.load(scope.recording);
                    };

                    scope.submitVideo = function () {
                        console.log('submitting video:');
                        console.log(scope.reply);
                        if (!scope.reply.video_id) {
                            $rootScope.$broadcast('open-message', scope.trans['submit-reply']);
                            return;
                        }
                        console.log(scope.loading);
                        console.log(scope.form.$valid);
                        if (scope.loading || !scope.form.$valid) {
                            return;
                        }
                        console.log(scope.recording);
                        if (!scope.recording) {
                            console.log('missing recording, opening message');
                            $rootScope.$broadcast('open-message', scope.trans['submit-warning']);
                            return;
                        }

                        var agreeMessage = scope.trans['submit-policy-tv-js'];

                        var business = config.params.business;
                        if (business && business.privacy_policy) {
                            agreeMessage = scope.trans['submit-policy-bz-js'];
                        }

                        var deferred = $q.defer();

                        deferred.promise.then(scope.postReply);

                        $rootScope.$broadcast('open-message-confirm', agreeMessage, deferred);
                    };

                    scope.sendReply = function () {
                        if (scope.loading || !scope.form.$valid) return;

                        scope.postReply();
                    };

                    scope.postReply = function () {
                        var params = {
                            reply: angular.copy(scope.reply),
                            recording: scope.replyOptionIndex === 1 ? angular.copy(scope.recording) : undefined,
                        };

                        scope.loading = true;

                        ajax.post('/api/reply', params).then(function (data) {
                            params = {};

                            if (params.recording) {
                                params.buttons = [
                                    { name: 'View Your Video', colorClass: 'btn--tertiary', href: '/video/reply/' + data.id },
                                ];
                            }

                            $rootScope.$broadcast('open-message', scope.trans['submit-success'], params);

                            scope.$emit('force-close-overlay');
                            scope.reply.message = '';

                            scope.form.$setUntouched();
                            scope.form.$setPristine();

                            scope.loading = false;

                            if (typeof gtag === 'function') {
                                gtag('event', 'landing page', { desc: 'send reply' });
                            }
                        }).catch(function () {
                            scope.loading = false;
                        });
                    };

                    scope.init();
                },
            };
        }]);
}());
